import { TOGGLE_PRICE } from './../const';

export default (toggle) => {
    return {type: TOGGLE_PRICE, toggle}
}
